<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-8">
        <div class="card-group mb-0">
          <div class="card p-4 position-relative">
            <div class="card-body">
              <form [formGroup]="forgotForm" (ngSubmit)="submit()">
                <h1>Forgot password</h1>
                @if (!hasBeenRequested) {
                  <p class="text-muted">
                    If you already have an account, but have forgotten the
                    credentials, fill in your registered email address below and
                    submit. You will receive an email with your username and
                    registered domain, and an option to set a new password.
                  </p>
                }

                @if (hasBeenRequested) {
                  <p class="text-muted">
                    If an account is associated with the provided email address,
                    you will receive an email with instructions to reset your
                    password.
                  </p>
                }

                @if (
                  forgotForm && forgotForm.errors && forgotForm.errors.global
                ) {
                  <div class="alert alert-danger" role="alert">
                    <i class="fa fa-lg fa-warning">&nbsp;</i
                    >{{ forgotForm.errors.global }}
                  </div>
                }
                @if (!hasBeenRequested) {
                  <div class="input-group mb-3 mb-3">
                    <span class="input-group-addon input-group-text"
                      ><i class="icon-envelope"></i
                    ></span>
                    <input
                      type="text"
                      class="form-control"
                      [class.is-invalid]="showFieldInvalid('email')"
                      placeholder="user@example.com"
                      id="email"
                      name="email"
                      formControlName="email"
                      required />
                    @if (showFieldInvalid('email')) {
                      <div class="invalid-feedback">
                        Enter your registered email address.
                      </div>
                    }
                  </div>
                }
                <div class="row">
                  <div class="col-6">
                    @if (!hasBeenRequested) {
                      <button
                        type="button"
                        [disabled]="forgotForm.invalid"
                        type="submit"
                        class="btn btn-primary px-4">
                        Submit
                      </button>
                    }
                  </div>
                  <div class="col-6 text-end">
                    @if (!hasBeenRequested) {
                      <a class="btn btn-link px-0" [routerLink]="['/login']"
                        >Back</a
                      >
                    }
                    @if (hasBeenRequested) {
                      <a
                        class="btn btn-link px-0"
                        (click)="unsetRequestedState()"
                        (keydown.enter)="unsetRequestedState()"
                        >Back</a
                      >
                    }
                  </div>
                </div>
              </form>
            </div>
            @if (loading) {
              <loader-line></loader-line>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
